var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 800,
    width: 800,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.003 8H5.997a6 6 0 0 0-6 6v36a6 6 0 0 0 6 6h52.006a6 6 0 0 0 6-6V14a6 6 0 0 0-6-6zm4 41.11L43.085 30.193l18.918-12.056v30.975zM5.997 10h52.006c2.206 0 4 1.794 4 4v1.766L34.468 33.313c-1.49.95-3.394.92-4.85-.07L1.997 14.47V14c0-2.206 1.794-4 4-4zm-4 6.885 19.185 13.04L1.997 49.111V16.885zM58.003 54H5.997a4.005 4.005 0 0 1-3.677-2.428l20.52-20.52 5.655 3.844a6.41 6.41 0 0 0 7.046.104l5.842-3.724L61.68 51.572A4.005 4.005 0 0 1 58.003 54z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.27e3c1f565047309da344e1049492e6e.svg";
export { ForwardRef as ReactComponent };